import { app } from '../../../../app';

class ApprovalFormsService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getApprovalFormsForCompany(companyId) {
        const url = `app/rest/companies/${companyId}/approvalforms`;
        return this.$http.get(url).then(({data}) => data);
    }

    createNewApprovalForm(companyId) {
        const url = `app/rest/companies/${companyId}/approvalforms`;
        return this.$http.post(url).then(({data}) => data);
    }

    updateApprovalForm(approvalForm, companyId) {
        const url = `app/rest/companies/${companyId}/approvalforms/${approvalForm.id}`;
        return this.$http.put(url, approvalForm).then(({data}) => data);
    }

    deleteApprovalForm(approvalFormId, companyId) {
        const url = `app/rest/companies/${companyId}/approvalforms/${approvalFormId}`;
        return this.$http.delete(url).then(({data}) => data);   
    }
}

app.service('ApprovalFormsService', ApprovalFormsService);



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/forms/approval-forms.service.js